import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Stack } from 'react-bootstrap';
import AOS from 'aos'
import 'aos/dist/aos.css'

const Features = React.forwardRef((props, ref) => {
    const [featuresCard] = useState([
        {
            Image: '/fexperience/assets/img/01-Features.png',
            Heading: 'Enhanced Product Visualization',
            servicePointOne: 'Augmented Reality (AR) Integration',
            servicePointOnePara: 'Enable users to visualize your products in their real-world environment using AR, enhancing the buying experience and boosting customer confidence.'
        },
        {
            Image: '/fexperience/assets/img/02-Features.png',
            Heading: 'Easy Access Via QR/Browser',
            servicePointOne: 'Scan the QR and Showcase Entire Catalog',
            servicePointOnePara: 'Market your worth-sharing products directly without physical limitation. Let QR be your entire catalogue, enabling people to explore/share your products with a few clicks. '
        },
        {
            Image: '/fexperience/assets/img/03-Features.png',
            Heading: '24X7 Global Access & AI enabled smart agent',
            servicePointOne: 'Instant Access Across Borders',
            servicePointOnePara: 'An intelligent, omnichannel AI agent that provides instant, human-like voice and text support to resolve product inquiries and boost customer satisfaction 24/7. '
        },
        {
            Image: '/fexperience/assets/img/04-Features.png',
            Heading: 'Interactive & Immersive 3D Product Visualisation',
            servicePointOne: 'Revolutionize Customer Engagement',
            servicePointOnePara: 'Enable the creation of interactive 3D models for products, allowing users to zoom, rotate, and explore every detail with unprecedented depth and clarity.',
        },
        {
            Image: '/fexperience/assets/img/05-Features.png',
            Heading: 'Animation, Interaction and 3D Views',
            servicePointOne: 'Immerse Your Audience with Virtual Tours',
            servicePointOnePara: 'Zoom, touch, rotate, split, and expand the product in 3D view to engage your audience with dynamic animation and interactive virtual tours.',
        },
        {
            Image: '/fexperience/assets/img/06-Features.png',
            Heading: 'Multi Language Support & Voice Over (Audio)',
            servicePointOne: 'Expand Reach and Engagement',
            servicePointOnePara: 'Add explainer audio to all the products to ensure easy accessibility and engagement across diverse linguistic audiences. ',
        },
    ]);

    useEffect(()=>{ 
        
         AOS.init({duration:2000})
    });
     
    return (
        <div className="FeaturesContainer mb-5" ref={ref}>
            <div className="ServiceContent mb-4">
                <Container>
                    <h1 className='text-center mt-5 mb-1 fontWeight-800' style={{ color: '#0F75D6' }}>Features</h1>
                    <h5>Craft a FXperience for every product, innovation, and idea that deserves to be showcased.</h5>
                    <Row style={{ justifyContent: 'center', marginTop: '3rem' }}>
                        {featuresCard.map((service, serviceIndex) => (
                            <Col md={12} sm={12} key={serviceIndex} style={{ margin: '20px 0' }}>
                                <div className={`FeaturesCard ${serviceIndex % 2 === 0 ? 'FeaturesCardOne' : 'FeaturesCardTwo'} ${serviceIndex % 2 === 0 ? 'text-start' : 'text-end'}`}  data-aos="zoom-in">
                                    <Stack direction='horizontal' gap={2} className={`align-items-center flex-column flex-md-row flex-lg-row ${serviceIndex % 2 === 0 ? '' : 'flex-column-reverse flex-md-row-reverse flex-lg-row-reverse'}`}>
                                        <img src={service.Image} alt="" className='img-fluid FeaturesImg' />
                                        <div>
                                            <h2 style={{ color: '#000' }}>{service.Heading}</h2>
                                            <div className="CardBodyText02">
                                                <ul>
                                                    <li style={{ listStyle: 'none' }}>
                                                        <Stack direction='vertical' gap={2}>
                                                            <div className="servicePoints">
                                                                <h5 style={{ color: '#0F75D6', fontWeight: 'bolder' }}>{service.servicePointOne}</h5>
                                                                <p style={{ fontSize: '1.2rem', color: '#000', fontWeight: '400', marginBottom: '0' }}>{service.servicePointOnePara}</p>
                                                            </div>
                                                        </Stack>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Stack>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </div>
    );
});

export default Features;
